export const MODAL_OVERLAY_CLASS =
  "fixed inset-0 z-50 bg-white/20 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0";

export const MODAL_SURFACE_CLASS =
  "rounded-3xl border-0 bg-white text-foreground shadow-2xl";

export const MODAL_GUTTER_WIDTH_CLASS =
  "w-[calc(100vw-2rem)] sm:w-[calc(100vw-4rem)]";

export const MODAL_CONTENT_MOTION_CLASS =
  "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95";

export const MODAL_SIDE_PANEL_SURFACE_CLASS =
  "border-l border-border bg-white text-foreground shadow-2xl";
